import {
  Box,
  Button,
  Chip,
  Container,
  IconButton,
  Pagination,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import useConfig from "../../../../hooks/useConfig";
import UserDownloadCredit from "./UserDownloadCredit";
import HttpService from "../../../../hooks/Https-services";
import PageRoutes, { APIRoutes } from "../../../../utils/constants";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import momentTimezone from "moment-timezone";
import moment from "moment-timezone";
import { Link } from "@mui/icons-material";
import DownloadPdfComponent from "../../../../Common/Component/DownloadPdfComponent";
import { LoadingButton } from "@mui/lab";
import DialogBox from "../../../../Common/Component/DialogBox";
import UserEmailHistory from "./UserEmailHistory";
const UserView = () => {
  const configData = useConfig();
  //   sendResetPasswordEmailById;
  const [isLoading, setIsLoading] = useState(false);
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [isButtonLoadingDeleteSub, setIsButtonLoadingDeleteSub] =
    useState(false);
  const [userDownloadCredit, setUserDownloadCredit] = useState<any>(null);
  const [useDetails, setUserDetails] = useState<any>(null);
  const [totalPage, setTotalPage] = useState(0);
  const [paymentLogs, setPaymentLogs] = useState([]);
  const [paymentHistory, setpaymentHistory] = useState([]);
  const [page, setPage] = useState(1);
  const { id }: any = useParams();
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleSendResetPasswordEmail = async () => {
    setIsLoading(true);
    try {
      const res = await HttpService.post(
        APIRoutes.SendResetPasswordEmailById.replace(":id", id),
        {}
      );

      toast.success("Email Sent Successful");
      setIsLoading(false);
    } catch (error: any) {
      setIsLoading(false);
      toast.error(error.response.data.message);
    }
  };
  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };
  const deactivateUser = async () => {
    if (useDetails?.Status !== 1) setIsButtonLoading(true);
    try {
      const res = await HttpService.post(
        `${APIRoutes.DeactivateUser.replace(":id", id)}?isActive=${
          useDetails?.Status === 1 ? "false" : "true"
        }`,
        {}
      );
      await GetUserDetailsByID();
      setIsButtonLoading(false);

      toast.success(
        `User ${
          useDetails?.Status === 1 ? "Deactivated" : "Activated"
        } Successfully`
      );
    } catch (error) {
      setIsButtonLoading(false);
    }
  };
  const handleDeletSub = async (sunId: string) => {
    setIsButtonLoadingDeleteSub(true);

    try {
      const res = await HttpService.post(
        `${APIRoutes.DeleteUsersSub.replace(":id", sunId)}`,
        {}
      );
      await GetUserDetailsByID();
      setIsButtonLoadingDeleteSub(false);

      toast.error(`User's Subscription Deleted Successfully`);
    } catch (error) {
      setIsButtonLoadingDeleteSub(false);
    }
  };
  const GetUserDetailsByID = useCallback(async () => {
    try {
      const res = await HttpService.get(
        APIRoutes.GetUserDetailsById.replace(":id", id)
      );
      if (res.data.data) {
        setUserDetails(res.data.data);
        setpaymentHistory(res.data.data?.PaymentHistory);
      }
    } catch (error: any) {
      toast.error(error.response.data.message);
      console.log(error);
    }
  }, [id]);
  const GetUserDownloadCreditByID = useCallback(async () => {
    try {
      const res = await HttpService.get(
        APIRoutes.GetUserDownloadTokensById.replace(":id", id)
      );
      if (res.data.data) setUserDownloadCredit(res.data.data);
    } catch (error: any) {
      toast.error(error.response.data.message);
      console.log(error);
    }
  }, [id]);
  const GetPaymentLogs = useCallback(async () => {
    try {
      const res = await HttpService.get(
        `${APIRoutes.GetPaymentLogs}?page=${page}&userId=${id}`
      );
      if (res) {
        setPaymentLogs(res.data.data?.logs);
        setTotalPage(res.data.data?.total_page);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }, [page, id]);
  useEffect(() => {
    Promise.all([GetUserDownloadCreditByID(), GetUserDetailsByID()])
      .then((res) => {})
      .finally(() => {});
  }, [GetUserDownloadCreditByID, GetUserDetailsByID]);
  useEffect(() => {
    Promise.all([GetPaymentLogs()])
      .then((res) => {})
      .finally(() => {});
  }, [GetPaymentLogs]);
  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 2, mt: 5 }}>
        <Box sx={{ width: 100, mb: 2 }}>
          <button
            style={{
              fontSize: "14px",
              padding: "8px",
              display: "flex",
              alignItems: "center",
            }}
            onClick={() => navigate(PageRoutes.Users)}
            className={configData.buttonCommonClass}
          >
            <ArrowBackIcon />
            Back
          </button>
        </Box>

        <Stack gap={6}>
          <Box>
            <Stack>
              <Typography variant="h5" sx={{ fontWeight: 600 }}>
                Password Reset
              </Typography>
              <Stack
                sx={{ mt: 2 }}
                direction={"row"}
                justifyContent={"space-between"}
                alignItems={"center"}
              >
                <Stack direction={"row"} gap={1}>
                  <Stack>
                    <Typography
                      variant="body1"
                      sx={{
                        fontStyle: "normal",
                        textTransform: "none",
                        fontWeight: 500,
                      }}
                    >
                      Email
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ fontStyle: "normal", textTransform: "none" }}
                    >
                      {useDetails?.Email}
                    </Typography>
                  </Stack>
                  {useDetails && (
                    <LoadingButton
                      loading={isButtonLoading}
                      onClick={() => {
                        if (useDetails?.Status === 1) {
                          handleClickOpen();
                        } else {
                          deactivateUser();
                        }
                      }}
                      variant="contained"
                      disabled={useDetails?.Subscription?.subscription}
                      color={useDetails?.Status === 1 ? "error" : "success"}
                    >
                      {useDetails?.Status === 1 ? "Deactivate" : "Activate"}
                    </LoadingButton>
                  )}
                </Stack>
                <Box>
                  <button
                    disabled={isLoading}
                    onClick={handleSendResetPasswordEmail}
                    style={{ fontSize: "14px" }}
                    className={configData.buttonCommonClass}
                  >
                    Send Password Reset
                  </button>
                </Box>
              </Stack>
            </Stack>
          </Box>
          {userDownloadCredit && (
            <Box>
              <Stack>
                <Typography variant="h5" sx={{ fontWeight: 600 }}>
                  User Download Credit
                </Typography>
                <UserDownloadCredit
                  userDownloadCredit={userDownloadCredit}
                  GetUserDownloadCreditByID={GetUserDownloadCreditByID}
                />
              </Stack>
            </Box>
          )}
          {useDetails?.Subscription && (
            <Box>
              <Stack>
                <Typography variant="h5" sx={{ fontWeight: 600 }}>
                  Plan Details{" "}
                  {useDetails?.Subscription?.subscription?.id && (
                    <>
                      <IconButton
                        target="_blank"
                        href={`https://dashboard.stripe.com/subscriptions/${useDetails?.Subscription?.subscription?.id}`}
                      >
                        <Link color="primary" />{" "}
                      </IconButton>
                      <LoadingButton
                        loading={isButtonLoadingDeleteSub}
                        onClick={() =>
                          handleDeletSub(
                            useDetails?.Subscription?.subscription?.id
                          )
                        }
                        variant="contained"
                        color="error"
                      >
                        Delete Subscription
                      </LoadingButton>
                    </>
                  )}
                </Typography>
                <Stack sx={{ mt: 2 }}>
                  {useDetails?.Subscription?.plan_type_id && (
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        textTransform: "capitalize",
                      }}
                    >
                      {useDetails?.Subscription?.plan_type_id == 3
                        ? "Single Game Access"
                        : `${useDetails?.Subscription?.subscription?.plan?.interval}ly Access`}
                      {useDetails?.Subscription?.plan_type_id != 3 &&
                        useDetails?.Subscription?.plan_type_id && (
                          <Chip
                            sx={{ ml: 0.5 }}
                            label={
                              useDetails?.Subscription?.subscription
                                ?.pause_collection
                                ? "Paused"
                                : useDetails?.Subscription?.subscription?.status
                                    ?.split("_")
                                    ?.join(" ")
                            }
                            color={
                              useDetails?.Subscription?.subscription
                                ?.pause_collection
                                ? "info"
                                : useDetails?.Subscription.subscription
                                    ?.status != "active"
                                ? "error"
                                : "success"
                            }
                          />
                        )}
                    </Typography>
                  )}
                  {useDetails?.Subscription?.subscription?.pause_collection ? (
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                        fontStyle: "normal",
                        textTransform: "none",
                      }}
                    >
                      User's plan is paused until{" "}
                      {moment
                        .unix(
                          useDetails?.Subscription?.subscription
                            ?.pause_collection?.resumes_at
                        )
                        .format("MMM DD, YYYY")}
                    </Typography>
                  ) : (
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                        fontStyle: "normal",
                        textTransform: "none",
                      }}
                    >
                      {!useDetails?.Subscription?.subscription
                        ?.cancel_at_period_end &&
                      useDetails?.Subscription?.plan_type_id != 3 &&
                      useDetails?.Subscription?.plan_type_id &&
                      !useDetails?.Subscription?.subscription?.canceled_at
                        ? `${
                            useDetails?.Subscription?.subscription?.plan
                              ?.amount / 100
                          } ${useDetails?.Subscription?.subscription?.plan?.currency?.toUpperCase()} (next payment 
                        ${momentTimezone
                          .unix(
                            useDetails?.Subscription.subscription
                              ?.current_period_end
                          )
                          .tz("America/New_York")
                          .format("YYYY-MM-DD")}
                        )`
                        : "No upcoming payments."}
                    </Typography>
                  )}

                  {useDetails?.Subscription?.plan_type_id != 3 &&
                    useDetails?.Subscription?.plan_type_id &&
                    !useDetails?.Subscription?.subscription
                      ?.pause_collection && (
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: 600,
                          fontStyle: "normal",
                          textTransform: "none",
                        }}
                      >
                        {!useDetails?.Subscription?.subscription
                          ?.cancel_at_period_end &&
                        !useDetails?.Subscription?.subscription?.canceled_at
                          ? `Renew 
                        ${momentTimezone
                          .unix(
                            useDetails?.Subscription.subscription
                              ?.current_period_end
                          )

                          .format("YYYY-MM-DD hh:mm A")}`
                          : "This plan will not auto-renew"}
                      </Typography>
                    )}
                </Stack>
              </Stack>
            </Box>
          )}
          {paymentHistory?.length !== 0 && (
            <Box>
              <Typography variant="h5" sx={{ fontWeight: 600, my: 2 }}>
                Payment History{" "}
                {useDetails?.StripePayments[0]?.CostomerID && (
                  <IconButton
                    target="_blank"
                    href={`https://dashboard.stripe.com/customers/${useDetails?.StripePayments[0]?.CostomerID}`}
                  >
                    <Link color="primary" />{" "}
                  </IconButton>
                )}
              </Typography>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Payment Invoices</TableCell>
                      <TableCell align="left">Description</TableCell>
                      <TableCell align="left">Amount</TableCell>
                      <TableCell align="left">Date</TableCell>
                      <TableCell align="left">Status</TableCell>
                      <TableCell align="left">Game</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paymentHistory
                      ?.sort(
                        (a: any, b: any) =>
                          b?.payment?.created - a?.payment?.created
                      )
                      ?.map((row: any, index: any) => (
                        <TableRow
                          key={index + 1}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell component="th" scope="row">
                            <DownloadPdfComponent row={row} />
                          </TableCell>
                          <TableCell align="left">
                            {row?.payment?.description
                              ? row?.payment?.description
                              : row?.payment?.billing_reason ==
                                "subscription_create"
                              ? "Subscription creation"
                              : row?.payment?.billing_reason ==
                                "subscription_update"
                              ? "Subscription update"
                              : "One time pass creation"}
                          </TableCell>{" "}
                          <TableCell align="left">
                            ${(row?.payment?.amount / 100).toFixed(2)}
                          </TableCell>
                          <TableCell align="left">
                            {moment
                              .unix(row?.payment?.created)
                              .utc()
                              .format("MMMM DD , YYYY hh:mm A")}{" "}
                            UTC
                          </TableCell>
                          <TableCell align="left">
                            {row?.payment?.status}
                          </TableCell>
                          <TableCell align="left">
                            {row?.payment?.description ==
                            "Gift Card Purchase" ? (
                              <>-</>
                            ) : (
                              <Button
                                variant="text"
                                onClick={() => {
                                  if (
                                    row?.invoice?.metadata?.PlanTypeID == "3"
                                  ) {
                                    navigate(
                                      PageRoutes.Watch.replace(
                                        ":gameId",
                                        row?.invoice?.metadata?.GameID
                                      )
                                    );
                                  }
                                }}
                              >
                                {row?.invoice?.metadata?.GameID}
                              </Button>
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 600, my: 2 }}>
              Customer Emails
            </Typography>
            <UserEmailHistory />
          </Box>
          {paymentLogs?.length !== 0 && (
            <Box>
              <Stack>
                <Typography variant="h5" sx={{ fontWeight: 600 }}>
                  Payment Logs{" "}
                  {useDetails?.StripePayments[0]?.CostomerID && (
                    <IconButton
                      target="_blank"
                      href={`https://dashboard.stripe.com/customers/${useDetails?.StripePayments[0]?.CostomerID}`}
                    >
                      <Link color="primary" />{" "}
                    </IconButton>
                  )}
                </Typography>
                <Stack sx={{ mt: 2, gap: 1 }}>
                  {paymentLogs?.map((el: any, index: number) => {
                    return (
                      <Typography
                        variant="body2"
                        sx={{ textTransform: "none", fontStyle: "normal" }}
                      >
                        {el?.AlertMessage?.replace("You", "User")?.replace(
                          "your",
                          "their"
                        )}{" "}
                        at{" "}
                        {moment(el.createdAt)
                          .utc()
                          .format("hh:mm A z [on] YYYY-MM-DD")}
                      </Typography>
                    );
                  })}
                </Stack>
              </Stack>
            </Box>
          )}
        </Stack>
        <DialogBox
          open={open}
          handleClose={handleClose}
          buttonAction={() => handleClose()}
          butttonTextSecondary={"Deactivate User"}
          buttonActionSecondary={async () => {
            await deactivateUser();
            handleClose();
          }}
          buttonText={"Close"}
          content={
            <Stack sx={{ textAlign: "center" }}>
              <Typography
                variant="subtitle2"
                sx={{
                  fontWeight: 600,
                  fontStyle: "normal !imporatant",
                  textTransform: "none",
                }}
              >
                {" "}
                Are you sure?
              </Typography>
              <Typography sx={{ fontStyle: "normal", textTransform: "none" }}>
                This will immediately revoke access to the system for the user.
                Are you sure you want to deactivate this user?
              </Typography>
            </Stack>
          }
        />
        {totalPage !== 1 && totalPage !== 0 && (
          <Pagination
            count={totalPage}
            sx={{ mt: 2 }}
            // @ts-ignore
            onChange={handleChangePage}
            page={page}
            showFirstButton
            showLastButton
          />
        )}
      </Box>
    </Container>
  );
};
export default UserView;
